<img role="presentation" src="/assets/icons/signet-bg.svg" [alt]="altText()" class="d-inline mr-2" />
